import { render, staticRenderFns } from "./FormDownload.vue?vue&type=template&id=c124be0a&scoped=true&"
import script from "./FormDownload.vue?vue&type=script&lang=js&"
export * from "./FormDownload.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c124be0a",
  null
  
)

export default component.exports